export default "<div class=\"theme-autumn no-bg\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"